import SteelCompass from 'services/SteelCompass';
import CourseActions from 'actions/Course';

class Course {
  reorderSections(id, sectionIds, callback) {
    SteelCompass.call(
      'course',
      'reorderSections',
      { id, sectionIds },
      response => {
        if (callback) {
          callback(response);
        }
      }
    );
  }

  save(data) {
    if (data.id < 0) {
      this.create(data);
    } else {
      this.update(data);
    }
  }

  addPage(sectionId, name, type) {
    return SteelCompass.request('page', 'create', { sectionId, name, type }).then(
      data => {
        if (data) {
          CourseActions.createPageComplete(sectionId, data);
        } else {
          CourseActions.genericError();
        }
        return data
      },
      error => {
        CourseActions.genericError(error);
      }
    );
  }

  updatePage(data) {
    return SteelCompass.request('page', 'update', data).then(
      response => {
        if (response) {
          CourseActions.updatePageComplete(data);
        } else {
          CourseActions.genericError();
        }
      },
      error => {
        CourseActions.genericError(error);
      }
    );
  }

  addSection(courseId, name, type = 'content') {
    return SteelCompass.request('section', 'create', { courseId, name, type }).then(
      data => {
        if (data) {
          CourseActions.createSectionComplete(data);
        } else {
          CourseActions.genericError();
        }
        return data
      },
      error => {
        CourseActions.genericError(error);
      }
    );
  }

  updateSection(data) {
    return SteelCompass.request('section', 'update', data).then(
      data => {
        if (data) {
          CourseActions.updateSectionComplete(data);
        } else {
          CourseActions.genericError();
        }
      },
      error => {
        CourseActions.genericError(error);
      }
    );
  }

  deleteSection(id) {
    return SteelCompass.request('section', 'delete', { id }).then(
      data => {
        if (data) {
          CourseActions.deleteSectionComplete(id);
        } else {
          CourseActions.genericError();
        }
      },
      error => {
        CourseActions.genericError(error);
      }
    );
  }

  deletePage(id) {
    return SteelCompass.request('page', 'delete', { id }).then(
      data => {
        if (data) {
          CourseActions.deletePageComplete(id);
        } else {
          CourseActions.genericError();
        }
      },
      error => {
        CourseActions.genericError(error);
      }
    );
  }

  update(data) {
    return SteelCompass.request('course', 'update', data).then(
      data => {
        if (data) {
          CourseActions.updateComplete(data);
        } else {
          CourseActions.genericError();
        }
      },
      error => {
        CourseActions.genericError(error);
      }
    );
  }

  create(data) {
    return SteelCompass.request('course', 'create', { name: data.name }).then(
      saveData => {
        CourseActions.createComplete(data.id);
        data.id = saveData.id;
        this.update(data);
      },
      error => {
        CourseActions.genericError(error);
      }
    );
  }
}

export default new Course();



// WEBPACK FOOTER //
// ./src/js/services/Course.js